(ns yardwerkz.web.domain.outline
  "Pure functions for outline/zone-related business logic.
   Copied from frontend/src/yardwerkz/domain/outline.cljs — zero RN deps.")

;; =============================================================================
;; Zone Tags
;; =============================================================================

(def zone-tags
  [{:id "front" :label "Front Yard" :icon "home"}
   {:id "back" :label "Back Yard" :icon "home-variant"}
   {:id "side-left" :label "Left Side" :icon "arrow-left-bold"}
   {:id "side-right" :label "Right Side" :icon "arrow-right-bold"}
   {:id "garden" :label "Garden" :icon "flower"}
   {:id "patio" :label "Patio/Deck" :icon "table-furniture"}
   {:id "driveway" :label "Driveway" :icon "road"}
   {:id "other" :label "Other" :icon "shape"}])

(defn get-zone-label [tag-id]
  (some #(when (= (:id %) tag-id) (:label %)) zone-tags))

(defn get-zone-icon [tag-id]
  (some #(when (= (:id %) tag-id) (:icon %)) zone-tags))

;; =============================================================================
;; Geometry Helpers
;; =============================================================================

(defn dist [[x1 y1] [x2 y2]]
  (js/Math.sqrt (+ (* (- x2 x1) (- x2 x1))
                   (* (- y2 y1) (- y2 y1)))))

(defn close-ring-once [coords]
  (let [coords (vec coords)]
    (if (and (seq coords)
             (not= (first coords) (peek coords)))
      (conj coords (first coords))
      coords)))

(defn valid-ring? [coords]
  (>= (count coords) 4))

(defn valid-geo? [geo]
  (boolean
   (and (seq geo)
        (every? #(and (:id %) (:coords %)) geo))))

(defn has-content? [active geo]
  (or (seq active) (seq geo)))
